import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/auth/forgot-password/ForgotPassword.tsx");
